<template>
  <div class="profitCalculationDetail">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <h2 style="margin-right: 20px;">{{ data.profitCalculation.id ? '编辑' : '新增' }}利润测算</h2>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button v-if="!data.profitCalculation.id" type="info" @click="data.profitCalculation = {}">清空</el-button>
          <el-button type="primary" @click="save()" :loading="show.saving">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-row :gutter="20" v-if="!data.profitCalculation.id || data.profitCalculation.beginDate">
        <el-col :span="12">
          <el-form-item label="测算区间">
            <el-date-picker v-model="data.dates" type="daterange" start-placeholder="起" end-placeholder="止" :disabled="data.profitCalculation.beginDate" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="">
            <el-button type="primary" v-if="!data.profitCalculation.beginDate" @click="submitDates()">选定测算区间</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="">
            <table class="table" style="text-align: center;" v-if="data.profitCalculation && data.profitCalculation.detailList">
              <tr>
                <td></td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-text v-if="detail.profitCalculationType == 'procure'">采购测算</el-text>
                  <el-text v-if="detail.profitCalculationType == 'sale'">销售测算</el-text>
                </td>
              </tr>
              <tr>
                <td></td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <template v-if="detail.profitCalculationType == 'procure'">
                    <el-text v-if="detail.productHeatType == 'HIGH'">高卡</el-text>
                    <el-text v-if="detail.productHeatType == 'MEDIUM'">中卡</el-text>
                    <el-text v-if="detail.productHeatType == 'LOW'">低卡</el-text>
                  </template>
                  <template v-if="detail.profitCalculationType == 'sale'">
                    <el-text>{{ detail.custom }}</el-text>
                  </template>
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>合同价</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="3" v-model="detail.contractPrice" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>热值</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.rezhi" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>硫</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.liu" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>调价累计</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.adjustmentAmount" />
                </td>
              </tr>
              <tr>
                <td>
                  <div style="height: 2px;"></div>
                </td>
              </tr>
              <tr>
                <td>
                  <el-link underline="never" @click="show.pcSettlementPriceFormulaDialog = true">
                    结算价
                    <el-icon>
                      <Link />
                    </el-icon>
                  </el-link>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.settlementPrice" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>煤本</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.productPrice" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>上游运费</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.upstreamTransportPrice" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>下游运费</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.downstreamTransportPrice" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-link underline="never" @click="show.pcDispatchPriceFormulaDialog = true">
                    调度费
                    <el-icon>
                      <Link />
                    </el-icon>
                  </el-link>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.dispatchPrice" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>费用</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.costAmount" />
                </td>
              </tr>
              <tr>
                <td>
                  <div style="height: 2px;"></div>
                </td>
              </tr>
              <tr>
                <td>
                  <el-link underline="never" @click="show.pcBusinessProfitFormulaDialog = true">
                    业务测算利润
                    <el-icon>
                      <Link />
                    </el-icon>
                  </el-link>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.businessProfit" />
                </td>
              </tr>
              <tr>
                <td>
                  <div style="height: 2px;"></div>
                </td>
              </tr>
              <tr>
                <td>
                  <el-link underline="never" @click="show.pcBeforeTaxProfitFormulaDialog = true">
                    税前利润
                    <el-icon>
                      <Link />
                    </el-icon>
                  </el-link>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.beforeTaxProfit" />
                </td>
              </tr>
              <tr>
                <td>
                  <div style="height: 2px;"></div>
                </td>
              </tr>
              <tr>
                <td>
                  <el-link underline="never" @click="show.pcNetProfitFormulaDialog = true">
                    净利润
                    <el-icon>
                      <Link />
                    </el-icon>
                  </el-link>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.netProfit" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>数量</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-input-number :controls="false" :precision="2" v-model="detail.quantity" />
                </td>
              </tr>
              <tr>
                <td>
                  <el-text>利润金额</el-text>
                </td>
                <td v-for="(detail, index) in data.profitCalculation.detailList" :key="index">
                  <el-text style="width: 100%; text-align: center;">
                    {{ math.formatNumber(math.multiply(detail.quantity, detail.netProfit)) }}
                  </el-text>
                </td>
              </tr>
            </table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>

  <el-dialog v-model="show.pcSettlementPriceFormulaDialog" title="选择结算价公式" width="650">
    <el-table :data="show.pcSettlementPriceFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text>{{ scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="90">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useFormula(scope.row, 'settlementPrice', 'pcSettlementPriceFormulaDialog')">使用</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog v-model="show.pcDispatchPriceFormulaDialog" title="选择调度费公式" width="650">
    <el-table :data="show.pcDispatchPriceFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text>{{ scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="90">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useFormula(scope.row, 'dispatchPrice', 'pcDispatchPriceFormulaDialog')">使用</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog v-model="show.pcBusinessProfitFormulaDialog" title="选择业务测算利润公式" width="650">
    <el-table :data="show.pcBusinessProfitFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text>{{ scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="90">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useFormula(scope.row, 'businessProfit', 'pcBusinessProfitFormulaDialog')">使用</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog v-model="show.pcBeforeTaxProfitFormulaDialog" title="选择税前利润公式" width="650">
    <el-table :data="show.pcBeforeTaxProfitFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text>{{ scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="90">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useFormula(scope.row, 'beforeTaxProfit', 'pcBeforeTaxProfitFormulaDialog')">使用</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog v-model="show.pcNetProfitFormulaDialog" title="选择净利润公式" width="650">
    <el-table :data="show.pcNetProfitFormulaList" :show-header="false">
      <el-table-column prop="name">
        <template #default="scope">
          <el-text>{{ scope.row.name }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="btn" width="90">
        <template #default="scope">
          <el-button-group>
            <el-button type="primary" @click="useFormula(scope.row, 'netProfit', 'pcNetProfitFormulaDialog')">使用</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>

</template>

<script setup>
import { reactive, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const show = reactive({
  saving: false,
  customList: [],
  storageList: [],
  productList: [],
  transportCompanyList: [],
  customNoteList: [],
  pcSettlementPriceFormulaList: [],
  pcSettlementPriceFormulaDialog: false,
  pcDispatchPriceFormulaList: [],
  pcDispatchPriceFormulaDialog: false,
  pcBusinessProfitFormulaList: [],
  pcBusinessProfitFormulaDialog: false,
  pcBeforeTaxProfitFormulaList: [],
  pcBeforeTaxProfitFormulaDialog: false,
  pcNetProfitFormulaList: [],
  pcNetProfitFormulaDialog: false,
})
const pageParam = cache.getObject(cache.keys.pageParam + "profitCalculationDetail")
const data = reactive({
  profitCalculation: {}
})
if (pageParam && pageParam.id) {
  data.profitCalculation.id = pageParam.id
  api.get('/backend/profitCalculation/getById', { params: { id: pageParam.id } }).then(res => {
    data.profitCalculation = res
    data.dates = [data.profitCalculation.beginDate, data.profitCalculation.endDate]
  })
} else {
  data.profitCalculation.id = null
}

// 查询公式选项
api.get('/backend/formula/get', { params: { model: 'pcSettlementPrice' } }).then(res => {
  show.pcSettlementPriceFormulaList = res.list
})
api.get('/backend/formula/get', { params: { model: 'pcDispatchPrice' } }).then(res => {
  show.pcDispatchPriceFormulaList = res.list
})
api.get('/backend/formula/get', { params: { model: 'pcBusinessProfit' } }).then(res => {
  show.pcBusinessProfitFormulaList = res.list
})
api.get('/backend/formula/get', { params: { model: 'pcBeforeTaxProfit' } }).then(res => {
  show.pcBeforeTaxProfitFormulaList = res.list
})
api.get('/backend/formula/get', { params: { model: 'pcNetProfit' } }).then(res => {
  show.pcNetProfitFormulaList = res.list
})

/** 选定日期区间 */
const submitDates = () => {
  if (data.dates && data.dates.length == 2) {
    data.profitCalculation.beginDate = util.parseTime(data.dates[0], '{y}-{m}-{d}')
    data.profitCalculation.endDate = util.parseTime(data.dates[1], '{y}-{m}-{d}')
    api.get('/backend/profitCalculation/before', {
      params: {
        dateGe: data.profitCalculation.beginDate,
        dateLe: data.profitCalculation.endDate
      }
    }).then(res => {
      data.profitCalculation.detailList = res.detailList
      ElMessage.success("已选定时间区间，请开始测算")
    })
  } else {
    ElMessage.error("请选择测算区间")
  }
}

/** 保存 */
const save = () => {
  if (show.saving) {
    return
  }
  const param = JSON.parse(JSON.stringify(data.profitCalculation))
  param.operateUser = null
  param.operateDatetime = null
  for (const detail of param.detailList) {
    detail.contractPrice = detail.contractPrice || 0
    detail.rezhi = detail.rezhi || 0
    detail.liu = detail.liu || 0
    detail.adjustmentAmount = detail.adjustmentAmount || 0
    detail.settlementPrice = detail.settlementPrice || 0
    detail.productPrice = detail.productPrice || 0
    detail.upstreamTransportPrice = detail.upstreamTransportPrice || 0
    detail.downstreamTransportPrice = detail.downstreamTransportPrice || 0
    detail.dispatchPrice = detail.dispatchPrice || 0
    detail.costAmount = detail.costAmount || 0
    detail.businessProfit = detail.businessProfit || 0
    detail.beforeTaxProfit = detail.beforeTaxProfit || 0
    detail.netProfit = detail.netProfit || 0
    detail.quantity = detail.quantity || 0
    detail.profitAmount = math.halfUp(math.multiply(detail.quantity, detail.netProfit), 2) || 0
  }
  show.saving = true
  if (!param.id) {
    api.post('/backend/profitCalculation/add', param).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      show.saving = false
    })
  } else {
    param.beginDate = null
    param.endDate = null
    api.post('/backend/profitCalculation/set', param).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      show.saving = false
    })
  }
}

/** 使用公式 */
const useFormula = (formula, paramName, dialogName) => {
  try {
    for (const detail of data.profitCalculation.detailList) {
      let 结果 = null
      const 合同价 = detail.contractPrice || 0
      const 热值 = detail.rezhi || 0
      const 硫 = detail.liu || 0
      const 调价累计 = detail.adjustmentAmount || 0
      const 结算价 = detail.settlementPrice || 0
      const 煤本 = detail.productPrice || 0
      const 上游运费 = detail.upstreamTransportPrice || 0
      const 下游运费 = detail.downstreamTransportPrice || 0
      const 调度费 = detail.dispatchPrice || 0
      const 费用 = detail.costAmount || 0
      const 业务测算利润 = detail.businessProfit || 0
      const 税前利润 = detail.beforeTaxProfit || 0
      const 净利润 = detail.netProfit || 0
      console.info(合同价, 热值, 硫, 调价累计, 结算价, 煤本, 上游运费, 下游运费, 调度费, 费用, 业务测算利润, 税前利润, 净利润)
      eval(formula.jsScript)
      if (结果 === null) {
        ElMessage.error('公式有误，请手动填写')
        return
      }
      detail[paramName] = math.halfUp(结果, 2)
    }
    show[dialogName] = false
  } catch (error) {
    ElMessage.error('公式有误，请手动填写')
    console.error(error)
  }
}
</script>

<style lang="less">
.profitCalculationDetail {
  margin: auto;

  .table {
    .el-input-number {
      width: 100%;
    }

    .el-input__wrapper {
      box-shadow: none;
    }
  }

  table {
    width: 100%;
    margin: 0;
    border-collapse: collapse;
  }

  table,
  th,
  td {
    border: 1px solid #ddd;
  }
}
</style>